export default function Inspections() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-gray-900">Inspections</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-500">Inspections functionality coming soon...</p>
      </div>
    </div>
  );
} 